/**
 * B2B VAT Exemption Form
 * Handles checkbox toggle and populates EU country dropdown
 * Dispatches 'b2b-vat-exemption-changed' event when form state changes
 */
(function () {
  'use strict';

  const _b2bVatFormLog =
    typeof window.createLogger === 'function'
      ? window.createLogger('B2BVatExemptionForm')
      : { log: () => {}, warn: () => {}, error: () => {} };
  const _b2bCheckoutFormLog =
    typeof window.createLogger === 'function'
      ? window.createLogger('B2BCheckoutValidator')
      : { log: () => {}, warn: () => {}, error: () => {} };

  function updateTaxNote(isChecked) {
    var taxNote = document.querySelector('.tax-note');
    if (taxNote && window.b2bVatTexts) {
      taxNote.textContent = isChecked ? window.b2bVatTexts.shippingOnly : window.b2bVatTexts.original;
    }
  }

  function updateAdditionalCheckoutButtons(isChecked) {
    var additionalCheckoutButtons = document.getElementById('cart-additional-checkout-buttons');
    if (additionalCheckoutButtons) {
      additionalCheckoutButtons.style.display = isChecked ? 'none' : 'block';
    }
  }

  function init() {
    var checkbox = document.getElementById('b2b-vat-exemption-checkbox');
    var formWrapper = document.getElementById('b2b-vat-exemption-form');

    if (!checkbox || !formWrapper) {
      _b2bVatFormLog.warn('Required elements not found');
      return;
    }

    checkbox.addEventListener('change', function () {
      var isChecked = checkbox.checked;
      checkbox.setAttribute('aria-expanded', isChecked.toString());

      updateTaxNote(isChecked);
      updateAdditionalCheckoutButtons(isChecked);

      if (isChecked) {
        // Remove hidden so scrollHeight is measurable, start from 0
        formWrapper.removeAttribute('hidden');
        formWrapper.style.height = '0';
        formWrapper.style.opacity = '0';
        // Read actual content height, then animate to it
        var openHeight = formWrapper.scrollHeight;
        requestAnimationFrame(function () {
          formWrapper.style.height = openHeight + 'px';
          formWrapper.style.opacity = '1';
        });
        // After animation completes, switch to auto so content reflows naturally
        formWrapper.addEventListener('transitionend', function onOpen(e) {
          if (e.propertyName === 'height' && checkbox.checked) {
            formWrapper.style.height = 'auto';
          }
          formWrapper.removeEventListener('transitionend', onOpen);
        });
        window.dispatchCustomEvent('B2B-customer-VAT-exemption-checked', {
          isB2BCustomer: true
        });
      } else {
        // Lock to explicit px before animating to 0 (required by CSS transitions)
        formWrapper.style.height = formWrapper.scrollHeight + 'px';
        formWrapper.style.opacity = '1';
        requestAnimationFrame(function () {
          formWrapper.style.height = '0';
          formWrapper.style.opacity = '0';
        });
        formWrapper.addEventListener('transitionend', function onClose(e) {
          if (e.propertyName === 'height') {
            if (!checkbox.checked) {
              formWrapper.setAttribute('hidden', '');
            }
            formWrapper.removeEventListener('transitionend', onClose);
          }
        });
        window.dispatchCustomEvent('B2B-customer-VAT-exemption-checked', {
          isB2BCustomer: false
        });
        // Hide confirmation message when checkbox is unchecked
        // hideConfirmationMessage();
      }

      dispatchFormState();
    });

    var vatInput = document.getElementById('b2b-vat-number');
    var businessInput = document.getElementById('b2b-business-name');
    var businessEmailInput = document.getElementById('b2b-business-email');

    if (vatInput) vatInput.addEventListener('input', dispatchFormState);
    if (businessInput) businessInput.addEventListener('input', dispatchFormState);
    if (businessEmailInput) businessEmailInput.addEventListener('input', dispatchFormState);

    var submitButton = document.getElementById('b2b-vat-submit');
    if (submitButton) {
      submitButton.addEventListener('click', function () {
        handleSubmit(vatInput, businessInput, businessEmailInput);
      });
    }

    _b2bVatFormLog.log('Initialized');
    const { destination } = window.CartItemsData;
    const is_EuCountry = window.is_EuCountry(destination);
    const b2bVatExemptionForm = document.getElementById('b2b-vat-exemption');
    if (b2bVatExemptionForm) {
      if (is_EuCountry) {
        b2bVatExemptionForm.style.display = 'block';
        autoFillB2BCustomer();
      } else {
        _b2bVatFormLog.warn('Does not a EU country:', destination);
        b2bVatExemptionForm.style.display = 'none';
      }
    } else {
      _b2bVatFormLog.warn('Form element not found for country code:', destination);
    }
  }

  function getCustomerData() {
    var el = document.getElementById('b2b-customer-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function autoFillB2BCustomer() {
    var customerData = getCustomerData();
    _b2bVatFormLog.log('Checking for B2B customer data to auto-fill form', customerData);
    if (!customerData || !customerData.id) return;

    var tags = customerData.tags || [];
    var isB2B = Array.isArray(tags)
      ? tags.some(function (tag) {
          return tag.toLowerCase() === 'b2b';
        })
      : false;

    if (!isB2B) return;

    _b2bVatFormLog.log('B2B customer detected – auto-filling form');

    var checkbox = document.getElementById('b2b-vat-exemption-checkbox');
    var formWrapper = document.getElementById('b2b-vat-exemption-form');

    if (checkbox && !checkbox.checked) {
      checkbox.checked = true;
      checkbox.setAttribute('aria-expanded', 'true');
      if (formWrapper) {
        formWrapper.removeAttribute('hidden');
        formWrapper.style.height = 'auto';
        formWrapper.style.opacity = '1';
      }
      updateTaxNote(true);
      updateAdditionalCheckoutButtons(true);

      // Dispatch after all DOMContentLoaded handlers have registered their listeners.
      // cart-totals-summary-eu-full.js registers its B2B listener inside DOMContentLoaded,
      // but this auto-fill runs during deferred-script execution (before DOMContentLoaded fires).
      // setTimeout(0) inside DOMContentLoaded ensures the event fires after every synchronous
      // DOMContentLoaded handler has completed.
      if (document.readyState === 'complete') {
        window.dispatchCustomEvent('B2B-customer-VAT-exemption-checked', { isB2BCustomer: true });
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          setTimeout(function () {
            window.dispatchCustomEvent('B2B-customer-VAT-exemption-checked', { isB2BCustomer: true });
          }, 0);
        });
      }
    }

    var vatInput = document.getElementById('b2b-vat-number');
    var businessEmailInput = document.getElementById('b2b-business-email');
    var businessInput = document.getElementById('b2b-business-name');

    if (vatInput && customerData.vat) vatInput.value = customerData.vat;
    if (businessEmailInput && customerData.email) businessEmailInput.value = customerData.email;
    if (businessInput) {
      var businessName = customerData.company || customerData.name || '';
      if (businessName) businessInput.value = businessName;
    }
  }

  async function handleSubmit(vatInput, businessInput, businessEmailInput) {
    var vatNumber = vatInput ? vatInput.value.trim() : '';
    var businessName = businessInput ? businessInput.value.trim() : '';
    var businessEmail = businessEmailInput ? businessEmailInput.value.trim() : '';
    var countryCodeCheckout = window.getSelectedMarketCountry() || window.Shopify?.country || 'GB';
    var vatCountry = String(countryCodeCheckout || 'GB').toUpperCase();
    const shoprate = Shopify.currency.rate;
    _b2bCheckoutFormLog.log('Submitting VAT info with country code:', vatCountry, 'and shop currency rate:', shoprate);
    var isValid = true;

    [vatInput, businessInput, businessEmailInput].forEach(function (el) {
      clearErrorState(el);
    });

    if (!vatNumber) {
      // if (vatInput) vatInput.classList.add('b2b-vat-exemption__field-input--error');
      setFieldError(vatInput, 'VAT number is required');
      isValid = false;
    }

    if (vatNumber) {
      var vatPrefix = vatNumber.substring(0, 2).toUpperCase();
      var selectedCountryCode = String(countryCodeCheckout || '').toUpperCase();
      if (!selectedCountryCode || vatPrefix !== selectedCountryCode) {
        setFieldError(vatInput, 'VAT is invalid');
        showToastError('VAT is invalid');
        isValid = false;
      }
    }
    if (!businessEmail) {
      setFieldError(businessEmailInput, 'Business email is required');
      isValid = false;
    } else {
      // Validate email format
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(businessEmail)) {
        setFieldError(businessEmailInput, 'Invalid email format');
        isValid = false;
      }
    }
    if (!businessName) {
      setFieldError(businessInput, 'Business name is required');
      isValid = false;
    }

    if (!isValid) {
      _b2bVatFormLog.warn('Validation failed – please fill in all fields');
      hideConfirmationMessage();
      return { success: false, reason: 'validation_failed' };
    }

    try {
      const response = await window.externalApiClient.saveCustomerVATInfo({
        name: businessName,
        email: businessEmail,
        vat: vatNumber,
        vatCountry: vatCountry,
        isVerified: false // optional, defaults to false
      });
      _b2bVatFormLog.log('Response:', response.message); // "Customer persisted in db."

      if (response && (response.message === 'VAT is invalid.' || response.message === 'VAT is invalid,')) {
        setFieldError(vatInput, response.message);
        hideConfirmationMessage();
        return { success: false, reason: 'vat_invalid', response: response };
      }

      // window.dispatchEvent(new CustomEvent('b2b-vat-exemption-submitted', { detail: detail }));

      // Show confirmation message after successful submission
      showConfirmationMessage();
      return { success: true, response: response };
    } catch (error) {
      _b2bVatFormLog.error('Failed to save VAT info:', error);
      return { success: false, reason: 'request_failed', error: error };
    }
  }

  async function submitCurrentForm() {
    var vatInput = document.getElementById('b2b-vat-number');
    var businessInput = document.getElementById('b2b-business-name');
    var businessEmailInput = document.getElementById('b2b-business-email');

    return handleSubmit(vatInput, businessInput, businessEmailInput);
  }

  function clearErrorState(el) {
    if (!el) return;

    el.classList.remove('b2b-vat-exemption__field-input--error');
    el.removeAttribute('aria-invalid');

    var errorElId = el.id ? el.id + '-error' : '';
    if (!errorElId) return;

    var errorEl = document.getElementById(errorElId);
    if (errorEl && errorEl.parentNode) {
      errorEl.parentNode.removeChild(errorEl);
    }
    el.removeAttribute('aria-describedby');
  }

  function setFieldError(el, message) {
    if (!el) return;

    clearErrorState(el);
    el.classList.add('b2b-vat-exemption__field-input--error');
    el.setAttribute('aria-invalid', 'true');

    if (!el.id) return;

    var errorElId = el.id + '-error';
    var errorEl = document.createElement('p');
    errorEl.id = errorElId;
    errorEl.style.margin = '0.4rem 0 0 0';
    errorEl.style.color = '#b91c1c';
    errorEl.style.fontSize = '0.9em';
    errorEl.textContent = message || 'Invalid value';

    el.insertAdjacentElement('afterend', errorEl);
    el.setAttribute('aria-describedby', errorElId);
  }

  async function showConfirmationMessage() {
    var confirmationEl = document.getElementById('b2b-vat-exemption-confirmation');
    if (confirmationEl) {
      // confirmationEl.style.display = 'block';
      // Scroll to submit button after a short delay to ensure it's fully visible
      // This allows the form to expand first
      setTimeout(function () {
        var submitButton = document.getElementById('b2b-vat-submit');
        if (submitButton) {
          submitButton.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 350); // Wait for CSS transition (0.3s) to complete
    }
  }

  function hideConfirmationMessage() {
    var confirmationEl = document.getElementById('b2b-vat-exemption-confirmation');
    if (confirmationEl) {
      confirmationEl.style.display = 'none';
    }
  }

  function showToastError(message) {
    if (window.N4YToast && typeof window.N4YToast.show === 'function') {
      window.N4YToast.show(message || 'VAT is invalid', { type: 'error', id: 'b2b-vat-exemption-toast' });
      return;
    }
    alert(message || 'VAT is invalid');
  }

  function dispatchFormState() {
    var checkbox = document.getElementById('b2b-vat-exemption-checkbox');
    var vatInput = document.getElementById('b2b-vat-number');
    var businessInput = document.getElementById('b2b-business-name');
    var businessEmailInput = document.getElementById('b2b-business-email');
    var countryCodeCheckout = window.getSelectedMarketCountry() || window.Shopify?.country || 'GB';
    var vatCountry = String(countryCodeCheckout || 'GB').toUpperCase();

    clearErrorState(vatInput);
    clearErrorState(businessInput);
    clearErrorState(businessEmailInput);

    // Hide confirmation message when form fields change (user is editing)
    hideConfirmationMessage();

    // var detail = {
    //   isB2B: checkbox ? checkbox.checked : false,
    //   vatNumber: vatInput ? vatInput.value.trim() : '',
    //   businessName: businessInput ? businessInput.value.trim() : '',
    //   businessEmail: businessEmailInput ? businessEmailInput.value.trim() : '',
    //   vatCountry: vatCountry
    // };

    // window.dispatchEvent(new CustomEvent('b2b-vat-exemption-changed', { detail: detail }));

    _b2bVatFormLog.log('State changed');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // b2b-checkout-validator sets this flag just before navigating to checkout.
  // On any page show (fresh load or bfcache restore), if the flag is present
  // we know the user is returning from checkout and must reset the checkbox.
  window.addEventListener('pageshow', function () {
    if (sessionStorage.getItem('b2b-reset-on-back')) {
      sessionStorage.removeItem('b2b-reset-on-back');
      var checkbox = document.getElementById('b2b-vat-exemption-checkbox');
      var formWrapper = document.getElementById('b2b-vat-exemption-form');
      if (checkbox) {
        checkbox.checked = false;
        checkbox.setAttribute('aria-expanded', 'false');
      }
      if (formWrapper) {
        formWrapper.removeAttribute('hidden');
        formWrapper.setAttribute('hidden', '');
        formWrapper.style.height = '0';
        formWrapper.style.opacity = '0';
      }
      updateTaxNote(false);
      updateAdditionalCheckoutButtons(false);
      autoFillB2BCustomer();
    }
  });

  window.B2BVatExemptionForm = window.B2BVatExemptionForm || {};
  window.B2BVatExemptionForm.handleSubmit = submitCurrentForm;
})();
